import { Container, Stack, Typography, Paper } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import {
  getOrganizationDetails,
  getOrganizationId,
} from 'src/services/user.service';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingScreen } from 'src/components/loading-screen';
import OrganizationProfile from '../organization-profile';
import FounderMessage from '../founder-message';
import CultureMessage from '../culture-message';
import JobListIntegration from '../job-list-integration';

export default function OrganizationView() {
  // hooks
  const { user } = useAuthContext();
  const orgId = getOrganizationId(user);

  // states
  const [about, setAbout] = useState('');
  const [candidateMessage, setCandidateMessage] = useState(null);
  const [cultureMessage, setCultureMessage] = useState(null);
  const [orgProfileImageUrl, setOrgProfileImageUrl] = useState('');
  const [orgName, setOrgName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [socialLinks, setSocialLinks] = useState([]);
  const isLoading = useBoolean(false);

  const fetchOrganizationDetails = useCallback(
    async (showLoader = true) => {
      if (showLoader) {
        isLoading.onTrue();
      }
      try {
        const response = await getOrganizationDetails(orgId);

        if (response.success) {
          const orgDetails = response.body;
          setOrgName(orgDetails.org_name);
          setOrgProfileImageUrl(orgDetails.org_logo_url || '');
          setAbout(orgDetails.about || '');
          setCandidateMessage(orgDetails.candidate_message || '');
          setCultureMessage(orgDetails.culture_message || '');

          if (orgDetails.website) setWebsiteUrl(orgDetails.website || '');

          const _socialLinks = [];

          _socialLinks.push({
            name: 'linkedIn',
            url: orgDetails.social_link_map?.LinkedIn
              ? orgDetails.social_link_map.LinkedIn
              : '',
          });
          _socialLinks.push({
            name: 'twitter',
            url: orgDetails.social_link_map?.Twitter
              ? orgDetails.social_link_map.Twitter
              : '',
          });
          _socialLinks.push({
            name: 'facebook',
            url: orgDetails.social_link_map?.Facebook
              ? orgDetails.social_link_map.Facebook
              : '',
          });
          _socialLinks.push({
            name: 'instagram',
            url: orgDetails.social_link_map?.Instagram
              ? orgDetails.social_link_map.Instagram
              : '',
          });
          _socialLinks.push({
            name: 'youtube',
            url: orgDetails.social_link_map?.Youtube
              ? orgDetails.social_link_map.Youtube
              : '',
          });

          setSocialLinks(_socialLinks);
        } else throw new Error(response.message);
      } catch (err) {
        console.log(err);
      } finally {
        isLoading.onFalse();
      }
    },
    [orgId],
  );

  const refetchOrgnizationDetails = async () => {
    await fetchOrganizationDetails(false);
  };

  // effects
  useEffect(() => {
    fetchOrganizationDetails();
  }, [fetchOrganizationDetails]);

  return isLoading.value ? (
    <LoadingScreen />
  ) : (
    <Container
      sx={{
        px: '60px',
        py: '40px',
      }}
    >
      <Stack>
        <Stack mb="40px">
          <Typography variant="h1">Organization</Typography>
        </Stack>
        <Stack spacing="24px">
          <OrganizationProfile
            orgId={orgId}
            orgProfileImageUrl={orgProfileImageUrl}
            about={about}
            socialLinks={socialLinks}
            websiteUrl={websiteUrl}
            orgName={orgName}
            refetch={refetchOrgnizationDetails}
          />
          {/* <FounderMessage
            orgId={orgId}
            refetch={refetchOrgnizationDetails}
            candidateMessage={candidateMessage}
          />
          <CultureMessage
            orgId={orgId}
            orgName={orgName}
            refetch={refetchOrgnizationDetails}
            cultureMessage={cultureMessage}
          /> */}
          <JobListIntegration orgId={orgId} />
        </Stack>
      </Stack>
    </Container>
  );
}
